import { render, staticRenderFns } from "./DepositDemo.vue?vue&type=template&id=6a1a12bd&scoped=true&"
import script from "./DepositDemo.vue?vue&type=script&lang=js&"
export * from "./DepositDemo.vue?vue&type=script&lang=js&"
import style0 from "./DepositDemo.vue?vue&type=style&index=0&id=6a1a12bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a12bd",
  null
  
)

export default component.exports